import type { ReactNode } from 'react';
import { Icon, AnMark } from '../../components/ui/Icon.js';

/**
 * The frame every signed-out screen shares: ArcNet's green panel on the left, the form centred on
 * the right. Sign in, set your password, an expired invitation and an invitation opened while signed
 * in all use it, so none of them is a lone card in a corner (owner, 18 September 2026: the
 * set-password page was "not centred and small").
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="arc-login">
      <aside className="arc-login-brand">
        <div className="arc-row" style={{ gap: 10 }}>
          <AnMark size={30} />
          <span style={{ fontSize: 16, fontWeight: 600, letterSpacing: '-.01em' }}>ArcNet</span>
        </div>

        <div className="arc-login-body">
          {/* Written for the people signing in -- an account's admins, agents and staff -- not for
              whoever runs the platform (owner, 28 September 2026). */}
          <p className="arc-login-lede">
            Your company's phones and calls, in one place.
          </p>
          <ul className="arc-login-points" style={{ marginTop: 22 }}>
            <li><Icon name="check" size={14} />Change extensions, numbers and where calls go, yourself</li>
            <li><Icon name="check" size={14} />Take calls in your browser or on your desk phone</li>
            <li><Icon name="check" size={14} />Call history, recordings and your team's queues</li>
          </ul>
        </div>

        <div className="arc-login-foot">Built in South Africa by Arcline Software</div>
      </aside>

      <div className="arc-login-panel">
        <div className="arc-login-card">{children}</div>
      </div>
    </div>
  );
}
